import { render, staticRenderFns } from "./UserLoyaltyList.vue?vue&type=template&id=67c2f76a"
import script from "./UserLoyaltyList.vue?vue&type=script&lang=js"
export * from "./UserLoyaltyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports